.shell {
	display: flex;
	flex-direction: column;
	min-block-size: 100vh;

	/* Dark mode personality: big, soft violet + pink glows fixed behind the top
	   chrome only (never behind dense board content), per the dark-mode research. */
	&::before {
		position: fixed;
		inset-block-start: 0;
		inset-inline: 0;
		z-index: 0;
		block-size: 30rem;
		pointer-events: none;
		content: '';
		background:
			radial-gradient(46rem 30rem at 20% -8%, var(--colour-glow-brand), transparent 62%),
			radial-gradient(42rem 28rem at 84% -6%, var(--colour-glow-accent), transparent 62%);

		/* Off in light, on in dark (token set per-theme). */
		opacity: var(--glow-opacity, 0);
	}

	> header,
	> main {
		position: relative;
		z-index: 1;
	}

	> header {
		position: sticky;
		inset-block-start: 0;
		z-index: var(--z-header);
		display: flex;
		gap: var(--spacing-4);
		align-items: center;
		padding: var(--spacing-3) var(--spacing-5);
		background-color: var(--colour-background-surface);
		border-block-end: 1px solid var(--colour-border-subtle);

		/* Logo link — wordmark in ink; the triangle carries the brand colour. */
		> a {
			display: inline-flex;
			color: var(--colour-text-primary);
		}

		/* App switcher stub */
		> nav {
			padding-inline-start: var(--spacing-4);
			font-size: var(--font-size-sm);
			font-weight: var(--font-weight-medium);
			color: var(--colour-text-secondary);
			text-transform: capitalize;
			border-inline-start: 1px solid var(--colour-border-subtle);
		}

		/* Actions group, pushed to the end */
		> div {
			display: flex;
			gap: var(--spacing-3);
			align-items: center;
			margin-inline-start: auto;
		}
	}

	> main {
		inline-size: 100%;
		max-inline-size: var(--width-content);
		padding: var(--spacing-5) var(--gutter);
		margin-inline: auto;
	}

	/* Full-bleed: drop the max-width cap so the content spans the viewport
	   (board / list views). Compound with `> main` so it wins on specificity. */
	& .fluid {
		max-inline-size: none;
	}
}

/* Phones: the single-row header can't hold logo + nav + actions, so wrap the nav
   onto its own full-width row beneath the logo and account controls. */
@media (width <= 640px) {
	.shell > header {
		flex-wrap: wrap;
		gap: var(--spacing-2) var(--spacing-3);
		padding-inline: var(--spacing-4);
	}

	.shell > header > nav {
		flex-basis: 100%;
		order: 3;
		padding-inline-start: 0;
		overflow-x: auto;
		border-inline-start: none;
	}

	.shell > header > div {
		order: 2;
	}

	.shell > main {
		padding-block: var(--spacing-4);
		padding-inline: var(--spacing-4);
	}
}

/* Key element: the account button can't be targeted structurally (a sibling of
   the theme toggle, also a <button>), so it keeps a class. */
.userMenu {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	inline-size: 2rem;
	block-size: 2rem;
	color: var(--colour-text-secondary);
	cursor: pointer;
	background-color: var(--colour-background-page);
	border: 1px solid var(--colour-border-subtle);
	border-radius: var(--radius-full);
}
